import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';

import CRMApi from '../../../Api/CRM/CRMApi';
import MenuItem from '../../../Api/Models/MenuItem';
import Card from '../../elements/common/Card';
import { SelectOptions } from '../../elements/formElements/Select';
import handleValidationErrors, { ValidationErrors } from '../../helpers/ResponseErrorHelper';
import { formatWithKey } from '../../helpers/formUtils';
import useBlockingSubmit from '../../hooks/useBlockingSubmit';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import useSmartField, { FieldChangeCallback } from '../../hooks/useSmartField';

export default function MenuItemCreate() {
    const history = useHistory();
    const { menuId } = useNumberParams();
    const [errors, setErrors] = useState<ValidationErrors>({});
    const [menuItem, setMenuItem] = useState<MenuItem>(new MenuItem({ menu_id: menuId }));
    const [menuList, setMenuList] = useState<SelectOptions>({});
    const [parentList, setParentList] = useState<SelectOptions>({});

    useOnce(() => CRMApi.menus.getNames().then(formatWithKey).then(setMenuList));

    useEffect(() => {
        if (menuItem.menu_id > 0) {
            CRMApi.menus.getMenuItemNames(menuItem.menu_id).then(formatWithKey).then(setParentList);
        }
    }, [menuItem.menu_id]);

    const handleFieldChange: FieldChangeCallback = (name, value) =>
        setMenuItem((prevItem) => prevItem.getNew({ [name]: value }));

    const Field = useSmartField({ errors, onChange: handleFieldChange });
    const [Submit, submitBlocked] = useBlockingSubmit();

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            await CRMApi.menuItems.store(menuItem);
            await swal({ title: 'Success', text: 'Menu Item created correctly', icon: 'success' });
            history.push(`/menus/${menuItem.menu_id}`);
        } catch (error) {
            handleValidationErrors(error, setErrors);
            submitBlocked(false);
        }
    };

    return (
        <Card>
            <form onSubmit={handleFormSubmit}>
                <Field type="number" name="order" value={menuItem.order} />
                <Field name="name" value={menuItem.name} />
                <Field name="url" value={menuItem.url} />
                <Field name="class" value={menuItem.class} />
                <Field type="checkbox" label="No follow" name="rel_nofollow" value={menuItem.rel_nofollow} />
                <Field type="select" name="menu_id" value={menuItem.menu_id} options={menuList} />
                <Field type="select" name="parent_id" value={menuItem.parent_id} options={parentList} />
                <Submit label="Create" />
            </form>
        </Card>
    );
}
